<template>
  <el-dropdown class="dropdown-menu-comp" :trigger="trigger">
    <component :is="menuType" class="el-dropdown-link">
      <slot name="menu"> {{ menu }} <i class="el-icon-arrow-down el-icon--right"></i> </slot>
    </component>

    <el-dropdown-menu class="operation-dropdown-menu" slot="dropdown">
      <el-dropdown-item>
        <div
          v-for="(item, index) in dropDownItems"
          :key="index"
          class="item"
          :class="item.type === 'dangerous' ? 'dangerous-teacher-btn' : ''"
          @click="submitAction(item)"
        >
          {{ item.label }}
        </div>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script lang="ts">
interface DropDownItem {
  label: string
  action: string
  type?: 'dangerous' | 'text'
}
import { BaseComponent, Component, Prop, Emit } from 'kuaidong-component'
@Component({
  components: {},
})
export default class DropdownMenu extends BaseComponent {
  @Prop({ type: String, required: false, default: 'span' })
  menuType?: 'span' | 'elButton'

  @Prop({ type: String, required: false, default: '更多' })
  menu?: string

  @Prop({ type: Array, required: true })
  dropDownItems!: DropDownItem[]

  @Prop({ type: Object, required: false })
  row?: any

  @Prop({ type: String, required: false, default: 'click' })
  trigger?: string

  @Emit('action')
  submitAction(item: DropDownItem) {
    return {
      action: item.action,
      row: this.row,
    }
  }
}
</script>

<style lang="less">
.dropdown-menu-comp {
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-weight: 500;
    font-size: 14px;
    &.el-button {
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
      color: #4d4d4d;
      padding: 9px 20px;
      &:hover {
        color: #409eff;
      }
    }
  }
}

.operation-dropdown-menu {
  .dangerous-teacher-btn {
    color: #f24b53;
  }
  .el-dropdown-menu__item:hover {
    background-color: transparent;
  }

  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: unset;
    color: unset;
  }

  .item {
    &:hover {
      color: #66b1ff;
    }
  }
}
</style>
